<template>
  <app-autocomplete
    filter
    :items="options"
    :label="$t('vouchers.customNumber')"
    label-icon="icon-hash"
    hide-details
    multiple
    dense
    solo
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { mapState } from 'vuex';
import { NAMESPACE } from '@/modules/Vouchers/store';

export default {
  name: 'VoucherNumberSelect',

  computed: {
    ...mapState(NAMESPACE, { items: 'voucherNumbers' }),
    options() {
      return [...new Set(this.items.map(({ number }) => number))];
    }
  }
};
</script>
